import { lazy } from "react";
import { RouteObject } from "react-router-dom";
const LandingPageAssignment = lazy(
  () => import("../../LandingPageManagement/components/LandingPageAssignment")
);
const RoleManagement = lazy(() => import("../components/RoleManagement"));
const RoleManagementContainer = lazy(
  () => import("../components/RoleManagementContainer/RoleManagementContainer")
);

const roleConfigRoute: RouteObject[] = [
  {
    path: "/settings/role-management",
    element: <RoleManagement />,
    children: [
      {
        index: true,
        element: <RoleManagementContainer />,
      },
      {
        path: "landing-page",
        element: <LandingPageAssignment />,
      },
    ],
  },
];

export default roleConfigRoute;
